const schedule = ({schedule}) => schedule.schedule;

export const selectors = {
    schedule
};
